module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-default-lincoln.c91eb8a5.png";